function equalizeCardHeights(containerSelector, cardSelector) {
  const containers = document.querySelectorAll(containerSelector);
  if (!containers.length) return;

  containers.forEach(container => {
    const cards = container.querySelectorAll(cardSelector);
    if (!cards.length) return;

    let maxHeight = 0;

    // Reset height first
    cards.forEach(card => {
      card.style.minHeight = "auto";
    });

    // Find max height for this container
    cards.forEach(card => {
      const cardHeight = card.offsetHeight;
      if (cardHeight > maxHeight) {
        maxHeight = cardHeight;
      }
    });

    // Apply max height to this container’s cards
    cards.forEach(card => {
      card.style.minHeight = maxHeight + "px";
    });
  });
}

function runEqualizers() {
  equalizeCardHeights(".blog--multicolumn", ".blog-article__title");  
  equalizeCardHeights(".ambassdor-multicolumn", ".custom-height__title");  
  equalizeCardHeights(".collectionseo-article_product", ".card-information .description");
}

// Run on load
runEqualizers();

// Run on resize
window.addEventListener("resize", runEqualizers);
